import React from 'react'
import { Outlet } from 'react-router-dom'

const LayoutAuth = () => {
    return (
        <>
            <Outlet />
        </>
    )
}

export default LayoutAuth